var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 73,
    viewBox: "0 0 75 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_13699)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3125,
    cy: 35.5,
    rx: 33.3125,
    ry: 32.5,
    fill: "#FFA400"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2217 51.1704H30.1939C30.1548 51.1527 30.1175 51.1251 30.0757 51.1189C27.5908 50.7036 26.0572 48.9064 26.0554 46.3871C26.0528 39.2749 26.0519 32.1617 26.0608 25.0494C26.0608 24.6092 26.1052 24.1575 26.211 23.7315C26.7347 21.6089 28.8701 20.0714 30.9398 20.3195C30.9541 20.4777 30.9692 20.6414 30.9834 20.8059C31.1728 23.1055 33.0682 25.125 35.3655 25.2797C37.1747 25.4016 39.0017 25.4113 40.8127 25.3153C43.1065 25.1944 44.8721 23.6355 45.3851 21.4648C45.474 21.0896 45.5033 20.7009 45.5638 20.2954C45.7256 20.2954 45.8918 20.2839 46.0545 20.2981C46.2964 20.3203 46.5408 20.3444 46.7773 20.3968C48.9368 20.8735 50.3949 22.6573 50.4198 24.8796C50.4375 26.4909 50.4242 28.1022 50.4242 29.7136C50.4242 35.2367 50.4269 40.7608 50.4224 46.284C50.4206 48.476 49.128 50.2865 47.1125 50.9366C46.8209 51.0308 46.5186 51.0931 46.2217 51.1696V51.1704ZM45.802 38.3349C45.8207 34.0514 42.3499 30.5601 38.0558 30.5415C33.7741 30.5228 30.2837 33.9962 30.2668 38.2913C30.2499 42.5838 33.7172 46.0883 37.9953 46.1043C42.3001 46.1204 45.7825 42.6531 45.8012 38.3349H45.802Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9007 18.0898C41.147 18.1814 41.4039 18.2499 41.6368 18.3673C42.6014 18.8555 43.1144 19.9431 42.877 20.9604C42.6317 22.0115 41.7426 22.7371 40.6384 22.7478C39.1537 22.762 37.669 22.7584 36.1843 22.7504C34.9476 22.7433 33.9323 21.7998 33.8221 20.5744C33.7172 19.4148 34.5164 18.3975 35.7291 18.1432C35.77 18.1343 35.8073 18.1076 35.8465 18.0898C37.5312 18.0898 39.2159 18.0898 40.9007 18.0898Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3778 38.4507C39.751 38.4507 40.052 38.4412 40.353 38.4507C41.4366 38.4961 42.289 39.3637 42.3035 40.4273C42.3179 41.5052 41.4535 42.4182 40.3506 42.4469C39.3441 42.4732 38.3352 42.4684 37.3262 42.4469C36.2065 42.4254 35.3613 41.5769 35.3493 40.4608C35.3349 39.0937 35.3373 37.7242 35.3493 36.3571C35.3589 35.2122 36.233 34.3446 37.3503 34.3399C38.4628 34.3351 39.3465 35.1979 39.3778 36.3403C39.3947 37.0215 39.3802 37.7026 39.3802 38.4483L39.3778 38.4507Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_13699",
    x: 0,
    y: 0,
    width: 74.625,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_13699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_13699",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingAction);
export default __webpack_public_path__ + "static/media/pendingAction.e302c293170716d472d1ad118a6d097c.svg";
export { ForwardRef as ReactComponent };